module.exports = __webpack_public_path__ + "static/service-skylights-45774a51b59d6ba665212684233491e4.jpg";